import 'core-js'

import React from 'react'
import ReactDOM from 'react-dom'

import Kursfinder from './Kursfinder'

var root = document.getElementById('kursfinder')

if (root) {
  /**
    * Initialize Kursfinder. Attach Kursfinder to DOM. Read the Course-Data provided via JSON.
    *
    * @var  courses           All available courses from the backend as JSON
    * @var  filterCategory    Find all available Categories from the courses. Manually add categories 90-93 for custom links.
    * @var  filterArea        Find all avaliable Areas (Schools) from the courses.
    * @var  filterLicense     Find al available License types from the courses. If the first item is "0", remove it, since there is no License Type "0".
    * @var  staticFilters     Combine the above filter possibilities.
    */

  const jsondata = root.getAttribute('data-courses')
  const view = root.getAttribute('data-view')
  const targetLink = root.getAttribute('data-targetlink')
  if (jsondata) {
    let courses = JSON.parse(jsondata)
    const filterCategory = [...new Set(courses.map(course => course.category))].filter(Boolean).sort()
    filterCategory.push('90', '91', '92', '93')
    const filterArea = [...new Set(courses.map(course => course.school))].filter(Boolean).sort((a, b) => a - b)
    const filterLicense = [...new Set(courses.map(course => course.license))].filter(Boolean).sort((a, b) => a - b)
    if (filterLicense[0] === '0') {
      filterLicense.shift()
    }
    const staticFilters = { category: filterCategory, school: filterArea, license: filterLicense }
    courses = courses.map(course => {
      const termine = Object.keys(course.termine).map(key => course.termine[key].item)
      return Object.assign({}, course, { termine })
    }) // TODO NACH OBEN UNTER COURSES
    ReactDOM.render(
      <Kursfinder view={view} courses={courses} staticFilters={staticFilters} targetLink={targetLink} />, root
    )
  }
}
